import { useEffect } from 'react';
import { useSpring } from '@react-spring/web';
import calculateOverflow from './calculateOverflow';
const useHorizontalScroll = ({ onScrollHandler, scrollRef, }) => {
    const getScrollWidth = () => { var _a, _b; return (_b = (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) !== null && _b !== void 0 ? _b : 0; };
    const getScrollContainerWidth = () => { var _a, _b; return (_b = (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0; };
    const getScrollLeft = () => { var _a, _b; return (_b = (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) !== null && _b !== void 0 ? _b : 0; };
    const getOverflow = () => calculateOverflow(getScrollWidth(), getScrollLeft(), getScrollContainerWidth());
    const [, scrollTo] = useSpring(() => ({
        x: getScrollLeft(),
        onChange: (animationResult) => {
            const { x } = animationResult.value;
            if (scrollRef.current) {
                scrollRef.current.scrollTo({
                    left: x,
                });
            }
        },
    }));
    const onScroll = (e) => {
        if (onScrollHandler)
            onScrollHandler(e);
    };
    useEffect(() => {
        var _a;
        (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', onScroll);
        return () => { var _a; return (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', onScroll); };
    });
    return {
        getScrollLeft,
        getScrollWidth,
        getScrollContainerWidth,
        scrollTo,
        getOverflow,
    };
};
export default useHorizontalScroll;
